<template>
    <footer>
      <div class="container info-container">
        <div class="info-box">
          <div class="info-box-title">数字化服务</div>
          <ul class="info-box-list">
            <li @click="openUrl('/service')">行业信息化咨询</li>
            <li @click="openUrl('/service')">定制化软件研发</li>
            <li @click="openUrl('/service')">第三方软件测试</li>
            <li @click="openUrl('/service')">系统化技术支持</li>
            <li @click="openUrl('/service')">软件服务外包（ITO）</li>
          </ul>
        </div>

        <div class="info-box">
          <div class="info-box-title">产品及解决方案</div>
          <ul class="info-box-list">
            <li @click="openUrl('/product/resourceManagement')">能源数据管理平台</li>
            <li @click="openUrl('/product/educloud')">云课堂</li>
            <li>鲸云诊所</li>
            <li @click="openUrl('/product/atp')">ATP测试机器人</li>
          </ul>
        </div>
        <!-- <div class="info-box">
          <div class="info-box-title">成功案例</div>
          <ul class="info-box-list">
            <li>云上天大馆</li>
            <li>陕鼓能源管理系统</li>
            <li>智慧燃气</li>
          </ul>
        </div> -->
        <div class="info-box">
          <div class="info-box-title">关于我们</div>
          <ul class="info-box-list">
            <li @click="openUrl('/aboutus/overview')">公司简介</li>
            <li @click="openUrl('/aboutus/history')">发展历程</li>
            <li @click="openUrl('/aboutus/honor')">资质荣誉</li>
            <li @click="openUrl('/aboutus/join')">加入我们</li>
            <li @click="openUrl('/aboutus/news')">新闻资讯</li>
          </ul>
        </div>

        <div class="info-box">
          <div class="info-box-title">联系我们</div>
          <div class="contact-box" style="">
            <i class="iconfont icondianhua contact-icon"></i>
            <div class="contact-info">
              <div class="contact-title">商务热线：</div>
              <div class="contact-phone">0756-6338632</div>
            </div>
          </div>
          <div class="contact-box" style="">
            <i class="iconfont icondianhua contact-icon"></i>
            <div class="contact-info">
              <div class="contact-title">服务热线：</div>
              <div class="contact-phone">0756-6338688</div>
            </div>
          </div>
          <div class="contact-box">
            <i class="iconfont iconyouxiang contact-icon"></i>
            <div class="contact-info">
              <div class="contact-title">合作邮箱：</div>
              <div class="contact-email">BD@apjcorp.com</div>
            </div>
          </div>
        </div>
        <img class="qrcode" src="@/assets/images/qrcBottom.jpg" />
      </div>
      <div class="container">
        <hr style="border-color: rgba(255, 255, 255, 0.3);" />
      </div>
      <div class="container copyright-container">
        <div>版权所有 &copy; 2002-2025 珠海爱浦京软件股份有限公司</div>
        <img class="recordImage" :src="require('@/assets/images/record.png')" />
        <div onclick="javaScript:window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496057')" style="cursor: pointer;">
          <span> 粤公网安备44049102496057号</span>
        </div>
        <div onclick="javaScript:window.open('http://beian.miit.gov.cn/')" style="cursor: pointer;">粤ICP备11029739号</div>
      </div>
    </footer>
</template>

<script>
export default {
  methods: {
    openUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>


<style lang="scss" scoped>

/** page style */
footer {
  width: 100%;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: #2f2f2f;
}

.info-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // padding: 0 0 50px;
  padding-bottom: 0;
  display: flex;
}

.info-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.info-box .info-box-title {
  font-size: 18px;
  color: #ffffff;
}

.info-box-list {
  padding: 0;
  margin: 20px 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.info-box-list li {
  padding: 10px 0 0;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.5);
}

.info-box-list li:hover {
  cursor: pointer;
  color: #ffffff;
}

.contact-box {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.contact-info {
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.contact-title {
  color: rgba(255, 255, 255, 0.5);
}

.contact-phone {
  font-size: 16px;
  line-height: 30px;
  color: #ffffff;
}

.contact-email {
  color: #ffffff;
}

.contact-icon {
  font-size: 32px;
  color: rgba(255, 255, 255, 0.5);
}

.copyright-container {
  display: flex;
  align-items: flex-start;
  // padding: 30px 0 0;
  padding-top: 30px;
}

.copyright-container div,span {
  padding-right: 20px;
  color: rgba(255, 255, 255, 0.5);
}

.qrcode {
  width: 120px;
  height: 120px;
  margin-top: 60px;
}

.recordImage{
  margin-top: 3px;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/page-footer/page-footer.vue